export const initialCodeOptions = {
  sortManual: false,
  background: true,
  bright: 80,
  font: 2,
  border: true,
  lines: 11,
  columns: 1,
};
